import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';
import {ApiService} from './api.service';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map'

@Injectable()
export class BranchService {
  public data: any ={};
    constructor(private http: Http, private apiService: ApiService) {}
    getProjectList() {
        return this.apiService.http_get('/tree/list/branch');
    }
    
    archivedProjects() {
        return this.apiService.http_get('/tree/archive/branch');
    }
    
    getAllProjects(data) {
        return this.apiService.http_post('/tree/projectlist', data);
    }
    
    createProject(project) {
        return this.apiService.http_post('/tree/create', project);
    }
    
    treeDetails(id){
         return this.apiService.http_post('/tree/treeDetails',id);
    }
    
    addQuestion(question){
         return this.apiService.http_post('/question/create',question);
    }
    
    editQuestion(question){
         return this.apiService.http_post('/question/update',question);
    }
    
    getProjectDetails(id){
          return this.apiService.http_get('/tree/details/'+id);
    }
    
    deleteQuestion(id){
          return this.apiService.http_post('/question/deleteQuestion',id);
    }
    getPublishedQuestions(id){
       
          return this.apiService.http_get('/tree/getPublishedQuestions/'+id);
    }
    updateProjectStatus(project){
       
        return this.apiService.http_post('/tree/changeProjectStatus', project);
    }
    deleteProject(project){
       
        return this.apiService.http_post('/tree/deleteProject', project);
    }
    reviseProject(project){
       
        return this.apiService.http_post('/tree/reviseProject', project);
    }
    
    updateProject(project){
        return this.apiService.http_post('/tree/update', project);
    }
    
    copyProject(logictree) {
        return this.apiService.http_post('/tree/copyProject', logictree);
    }
    
    deleteOption(option){
          return this.apiService.http_post('/question/deleteOption',option);
    }

    saveLogic(formData){
          return this.apiService.http_post('/question/saveLogic',formData);
    }
     getChartData() {
        return this.apiService.http_get('/question/getChartData');
    }

    
    importQuestions(fileToUpload: File){
//        const formData = new FormData();
//        formData.append('file', fileToUpload['document'][0], fileToUpload['document'][0].name);  
//        formData.append('metadata', new Blob([JSON.stringify(fileToUpload['document'][0])], {type: "application/json"}));
        
        let file: File = fileToUpload['document'][0];
        let formData:FormData = new FormData();
        formData.append('file', file, file.name);
        formData.append('filename', file.name);
        formData.append('projectId', fileToUpload['projectId']);
        
        return this.apiService.http_post('/question/importQuestions',formData);
    }


}



// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/_services/branch.service.ts